import { render, staticRenderFns } from "./DocumentExpirationAlertModal.vue?vue&type=template&id=265f4d94"
import script from "./DocumentExpirationAlertModal.vue?vue&type=script&lang=ts"
export * from "./DocumentExpirationAlertModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports